import React from "react";
import { careEnvironment } from "@akina/config";
import { isApp } from "@akina/utils";

type ExternalLinkProps = {
  href?: string;
  children: React.ReactNode;
  title?: string;
  className?: string;
};

const envToCareBaseUrl = {
  dev: "https://care-dev.akina.health",
  staging: "https://care-staging.akina.health",
  prod: "https://care.akina.health",
};

export const ExternalLink: React.FC<ExternalLinkProps> = ({ href, children, title, className }) => {
  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (isApp) {
      if (href?.startsWith("/")) {
        const baseUrl = envToCareBaseUrl[careEnvironment.environment];
        href = baseUrl + href;
      }
      try {
        const { openPath } = await import("@tauri-apps/plugin-opener");
        href && (await openPath(href));
      } catch (error) {
        console.error("Failed to open path via Tauri opener plugin:", error);
      }
    } else {
      window.open(href, "_blank", "noreferrer");
    }
  };

  return (
    <a href={href} onClick={handleClick} className={className} title={title}>
      {children}
    </a>
  );
};
